import HexController from 'controllers/hex_controller';
import { debounce } from 'underscore';

export default class extends HexController {
  static targets = ['name', 'nameField', 'saveButton', 'form', 'errorMessage'];
  static values = {
    checkNameUrl: String,
    authenticityToken: String,
    editable: Boolean
  };

  _lastCheckedName = '';
  _didSubmit = false;

  connect() {
    this.nameFieldTarget.addEventListener('input', debounce(() => {
      this.checkName();
    }, 500));
    this.formTarget.addEventListener('turbo:submit-start', () => {
      this.submitStart();
    });
    this.formTarget.addEventListener('turbo:submit-end', e => {
      this.submitEnd(e);
    });
  }

  submitStart() {
    this._didSubmit = true;
  }

  _nameChanged() {
    if (this.hasNameTarget) {
      return this.nameFieldTarget.value.trim() !== this.nameTarget.textContent.trim();
    }
    return true;
  }

  showEditNameForm(e) {
    e.preventDefault();
    this.formTarget.classList.remove('hidden');
    if (this.hasNameTarget) {
      this.nameTarget.classList.add('hidden');
    }
    this.nameFieldTarget.focus();
    // Move the cursor to the end of the name field
    this.nameFieldTarget.setSelectionRange(this.nameFieldTarget.value.length, this.nameFieldTarget.value.length);
  }

  showNameLabel() {
    this.formTarget.classList.add('hidden');
    if (this.hasNameTarget) {
      this.nameTarget.classList.remove('hidden');
    }
    this._validName();
  }

  setErrorMessage(status) {
    if (status === undefined || status === null) {
      this.errorMessageTarget.classList.add('hidden');
      return;
    }
    switch (status) {
      case 409:
        this.errorMessageTarget.textContent = this.t('Name is already taken');
        this.errorMessageTarget.classList.remove('hidden');
        break;
      case 422:
        this.errorMessageTarget.textContent = this.t('The name must contain at least one alphanumeric character, and can otherwise only include underscores, dashes, and spaces.');
        this.errorMessageTarget.classList.remove('hidden');
        break;
      default:
        this.errorMessageTarget.textContent = this.t('An error occurred');
    }
  }

  submitEnd(e, cancel = false) {
    if (cancel) {
      this._didSubmit = false;
      if (this.hasNameTarget) {
        this.nameFieldTarget.value = this.nameTarget.textContent.trim();
      }
      this.showNameLabel();
    } else {
      if (this.hasNameTarget) {
        this.nameTarget.textContent = this.nameFieldTarget.value.trim();
      }
      const { detail: { success } } = e;
      if (!success) {
        this._didSubmit = false;
        this._invalidName();
        this.setErrorMessage(e.detail.fetchResponse.response.status)
      } else {
        this.showNameLabel();
      }
    }
  }

  checkName() {
    const newName = this.nameFieldTarget.value.trim();
    if (newName.length > 0) {
      this._lastCheckedName = newName;
      fetch(this.checkNameUrlValue, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          name: this._lastCheckedName,
          authenticity_token: this.authenticityTokenValue
        })
      }).then(response => {
        if (!this._didSubmit) {
          if (response.status === 200) {
            this._validName();
            this.setErrorMessage(null);
          } else {
            this._invalidName();
            this.setErrorMessage(response.status);
          }
        }
      });
    } else {
      if (!this._didSubmit) {
        this._invalidName();
        this.setErrorMessage(422);
      }
    }
  }

  _invalidName() {
    this.nameFieldTarget.classList.add('is-invalid');
    this.saveButtonTarget.disabled = true;
  }

  _validName() {
    this.nameFieldTarget.classList.remove('is-invalid');
    this.saveButtonTarget.disabled = false;
  }

  resetNameValidation() {
    this._validName();
  }

  handleEnterAndEscape(e) {
    if (e.key === 'Escape') {
      this.submitEnd(e, true);
    }
    if (e.key === 'Enter') {
      this.cancelIfNotChanged(e);
    }
  }

  cancelIfNotChanged(e) {
    if (!this._nameChanged()) {
      e.preventDefault();
      this.submitEnd(e, true);
    }
  }
}
